export const Environment = {
  paypalClientId: () => process.env.REACT_APP_PAYPAL_CLIENT_ID,
  googleRecaptchaSiteKey: () => process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY,
};
